import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms'
import { FormsService } from '../services/forms-service.service';

@Component({
  selector: 'inputTextArea',
  templateUrl: './input-textArea.component.html',
  styleUrls: ['./input-textArea.component.css']
})
export class InputTextAreaComponent implements OnInit {

  public errorText: string;
  private isCleaner: boolean = false;
  public hideElement: boolean = false;
  @Input('Filter') filter: string;
  @Input('FilterName') filterName: string;
  @Input('formName') formName: string;
  @Input('parent') parent: FormGroup;
  @Input('value') value: any = null;
  @Input('readonly')
  set setReadOnly(readonly: boolean) {
    if (readonly != null && this.parent != null) {
      if (readonly) {
        this.parent.controls[this.formName].disable();
      } else {
        this.parent.controls[this.formName].enable();
      }
    }
  };
  private _EnableName;
  @Input('enableName')
  set setEnableName(enableName: string) {
    this._EnableName = enableName;
    this.checkEnable();
  };
  private _HiddenName;
  @Input('hiddenName')
  set setHiddenName(hiddenName: string) {
    this._HiddenName = hiddenName;
    this.checkHidden();
  };

  constructor(private FormsService: FormsService) {
    FormsService.EnableDisabledList$.subscribe(value => {
      this.checkEnable();
      this.checkHidden();
    });
  }

  ngOnInit() {
    this.errorText = "Campo obligatorio";
    if (this.parent.controls[this.formName].errors) {
      if (this.parent.controls[this.formName].errors.required) {
        this.filterName = this.filterName + "*";
      }
    }else if(this.parent.controls[this.formName].status == 'DISABLED' && this.parent.controls[this.formName].validator){
      this.filterName = this.filterName + "*";
    }
  }

  cleanInput() {
    this.parent.controls[this.formName].reset();
  }

  checkEnable() {
    if (this._EnableName != null && this.parent != null) {
      if (this.FormsService.ElementEnabled(this._EnableName)) {
        this.parent.controls[this.formName].enable();
      } else {
        this.parent.controls[this.formName].disable();
      }
    }
  }

  checkHidden() {
    if (this._HiddenName != null && this.parent != null) {
      if (this.FormsService.ElementHidden(this._HiddenName)) {
        this.hideElement = true;
      } else {
        this.hideElement = false;
      }
    }
  }
}